var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpired(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 82,
    viewBox: "0 0 86 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6659 72.9998C8.56614 72.9998 2 66.5829 2 58.6673C2 50.7516 8.56614 44.3347 16.6659 44.3347C17.0103 44.3347 17.352 44.3463 17.6905 44.3691C17.4553 43.06 17.3325 41.7118 17.3325 40.3349C17.3325 27.8171 27.4802 17.6694 39.998 17.6694C49.9915 17.6694 58.4744 24.1371 61.4893 33.1149C62.2036 33.0403 62.929 33.002 63.6634 33.002C74.8926 33.002 83.9957 41.9558 83.9957 53.0009C83.9957 63.4941 75.7796 72.1514 65.33 72.9853V72.9998H27.6705H16.6659ZM24.6628 72.9998H20.02H24.6628Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6628 72.9998H20.02M16.6659 72.9998C8.56614 72.9998 2 66.5829 2 58.6673C2 50.7516 8.56614 44.3347 16.6659 44.3347C17.0103 44.3347 17.352 44.3463 17.6905 44.3691C17.4553 43.06 17.3325 41.7118 17.3325 40.3349C17.3325 27.8171 27.4802 17.6694 39.998 17.6694C49.9915 17.6694 58.4744 24.1371 61.4893 33.1149C62.2036 33.0403 62.9289 33.002 63.6634 33.002C74.8926 33.002 83.9957 41.9558 83.9957 53.0009C83.9957 63.4941 75.7796 72.1514 65.33 72.9853V72.9998H27.6705H16.6659Z",
    stroke: "#00A4BF",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0527 22.5645C33.0527 44.0454 52.3987 61.746 77.3088 64.1358C74.1872 67.9744 69.3663 70.5785 63.8742 70.9877V71.0002H19.1406C13.7131 71.0002 4.646 68.7134 4.646 58.6997C4.646 48.686 11.6951 46.3993 19.1406 46.3993C19.4572 46.3993 19.7713 46.4092 20.0824 46.4288C19.8662 45.3053 19.8282 44.1472 19.7534 42.9666C19.2478 34.9915 22.727 24.9406 33.0648 21.6694C33.0565 21.9676 33.0527 22.2657 33.0527 22.5645ZM40.055 56.1729C38.0293 56.1729 36.3871 57.7956 36.3871 59.7973C36.3871 61.7991 38.0293 63.4218 40.055 63.4218C42.0807 63.4218 43.7229 61.7991 43.7229 59.7973C43.7229 57.7956 42.0807 56.1729 40.055 56.1729Z",
    fill: "#F0FBFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3125 63.663C42.3374 63.663 43.9789 62.0215 43.9789 59.9966C43.9789 57.9716 42.3374 56.3301 40.3125 56.3301C38.2875 56.3301 36.646 57.9716 36.646 59.9966C36.646 62.0215 38.2875 63.663 40.3125 63.663Z",
    stroke: "#00A4BF",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30 52.3339L34.6664 48.672L30 45.186",
    stroke: "#00A4BF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.646 52.3339L45.9796 48.672L50.646 45.186",
    stroke: "#00A4BF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6516 24.3306C50.9906 25.4789 54.4167 28.8722 55.6113 33.1922",
    stroke: "#00BADB",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6459 12.9998C61.7504 12.9998 62.6458 12.1044 62.6458 10.9999C62.6458 9.89538 61.7504 9 60.6459 9C59.5414 9 58.646 9.89538 58.646 10.9999C58.646 12.1044 59.5414 12.9998 60.6459 12.9998Z",
    stroke: "#00BADB",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3544 23.6692C82.4589 23.6692 83.3543 22.7738 83.3543 21.6693C83.3543 20.5648 82.4589 19.6694 81.3544 19.6694C80.2499 19.6694 79.3545 20.5648 79.3545 21.6693C79.3545 22.7738 80.2499 23.6692 81.3544 23.6692Z",
    fill: "#00BADB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8613 18.1738L71.4332 23.7457M71.5179 18.1738L65.946 23.7457L71.5179 18.1738Z",
    stroke: "#00BADB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.94434 30.0645L6.94412 34.0642M6.94412 30.0645L2.94434 34.0642L6.94412 30.0645Z",
    stroke: "#00BADB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 25.6692C13.1044 25.6692 13.9998 24.7738 13.9998 23.6693C13.9998 22.5648 13.1044 21.6694 11.9999 21.6694C10.8954 21.6694 10 22.5648 10 23.6693C10 24.7738 10.8954 25.6692 11.9999 25.6692Z",
    fill: "#00BADB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpired);
export default __webpack_public_path__ + "static/media/expired.c71257fea9f5adba61e9bf427485834b.svg";
export { ForwardRef as ReactComponent };